import {RelationNamePipe} from './../../shared/pipes/relationName.pipe';
import {UBOComponent} from 'app/entities/relations/relationship/ubo/ubo.component';
import {ImportRelationComponent} from './relationship/import-relation/import-relation.component';
import {ConfirmDeleteRelationshipComponent} from './relationship/confirmdeleterelationship/confirmdeleterelationship.component';
import {RelationshipDiagramComponent} from './relationship/relationship-diagram/relationship-diagram.component';
import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '@angular/material';
import {BrowserModule} from '@angular/platform-browser';
import {DomSanitizer} from '@angular/platform-browser';
import {AppRoutingModule} from 'app/app-routing.module';
import {SharedModule} from 'app/shared/shared.module';
import {EntityRelationsService} from 'app/entities/relations/entity-relations.service';
import {RelationshipComponent} from 'app/entities/relations/relationship/relationship.component';
import {EntityRelationsComponent} from 'app/entities/relations/entity-relations.component';
import {ReverseRelationshipComponent} from './reverse-relationship/reverse-relationship.component';

import {AddRelationComponent} from './relationship/addrelation/add-relation.component';
import {CalendarModule, ConfirmDialogModule, EditorModule} from 'primeng/primeng';
import {EditRelationshipComponent} from 'app/entities/relations/editrelationship/edit-relationship.component';
import {InfiniteScrollModule} from 'angular2-infinite-scroll';
import {ApplicationValueName} from '../../shared/pipes/application.value.pipe';

@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {
  }

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@NgModule({
  declarations: [
    EntityRelationsComponent,
    RelationshipComponent,
    ReverseRelationshipComponent,
    SafeHtmlPipe,
    RelationshipDiagramComponent,
    ConfirmDeleteRelationshipComponent,
    UBOComponent,
    AddRelationComponent,
    ImportRelationComponent,
    EditRelationshipComponent,
    ApplicationValueName,
    RelationNamePipe,
  ],
  imports: [
    MaterialModule.forRoot(),
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    FlexLayoutModule,
    SharedModule,
    AppRoutingModule,
    CalendarModule,
    ConfirmDialogModule,
    EditorModule,
    InfiniteScrollModule
  ],
  exports: [
    EntityRelationsComponent
  ],
  entryComponents: [
    RelationshipDiagramComponent,
    ConfirmDeleteRelationshipComponent,
    UBOComponent,
    AddRelationComponent,
    ImportRelationComponent,
    EditRelationshipComponent
  ],
  providers: [
    EntityRelationsService
  ]
})

/**
 * Main module for the entity relation tab management.
 *
 * @author raj.sharma@vernuso.com (Raj Sharma)
 */
export class EntityRelationsModule {
}



// WEBPACK FOOTER //
// ./src/app/entities/relations/entity-relations.module.ts